module.exports = __webpack_public_path__ + "img/recaptcha.23065c96.jpeg";